import axios from "axios";

export default {
    GetData(context, advancedQueryCriteria) {
        let postData = {};
        if (advancedQueryCriteria.Realtional !== null || advancedQueryCriteria.MrAttributes !== null) {
            postData = advancedQueryCriteria;
        }

        return axios({
            url: `${process.env.VUE_APP_API_URL}/tumour/data/${context.type}/${context.id}`,
            method: "POST",
            data: postData,
        });
    },
    GetKaplanMeierEstimates(context, kaplanMeierParameter, advancedQueryCriteria, state) {
        let postData = {};
        if (advancedQueryCriteria.Realtional !== null || advancedQueryCriteria.MrAttributes !== null) {
            postData = advancedQueryCriteria;
        }

        return axios({
            url: `${process.env.VUE_APP_API_URL}/tumour/KaplanMeierStatistics/${context.type}/${context.id}`,
            method: "POST",
            params: { durationInYears: 5, terminationCriteria: "DeathByDisease" },
            data: postData,
        });
    },
    GetKaplanMeierEstimatesAsExcelExport(context, kaplanMeierParameter, advancedQueryCriteria, state) {
        return axios({
            url: `${process.env.VUE_APP_API_URL}/tumour/ExportKaplanMeierStatistics/${context.type}/${context.id}`,
            method: "POST",
            params: { durationInYears: 5, terminationCriteria: "DeathByDisease" },
            responseType: "blob",
            data: advancedQueryCriteria,
        }).then((fileResponse) => {
            let d = new Date();
            let timestamp = `${d
                .toISOString()
                .substr(2, 14)
                .replace(new RegExp("-", "g"), "")
                .replace("T", "-")
                .replace(":", "")}`;
            const filename = `${timestamp}_kaplan-meier_export.xlsx`;

            // emulate clicking a link to a file
            const url = window.URL.createObjectURL(new Blob([fileResponse.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
        });
    },
    GetNationalData(advancedQueryCriteria) {
        return axios({
            url: `${process.env.VUE_APP_API_URL}/tumour/nationalData`,
            method: "POST",
            data: advancedQueryCriteria,
        });
    },
    GetMrAttributes() {
        return axios.get(`${process.env.VUE_APP_API_URL}/tumour/retrieveIndexedMrAttributes`);
    },
};
